<template>
<div style="background: #f0f4f7">
  <AboutBanner v-if="$route.path==='/sub/light-blocks/agencies-form'"
               :content="banners.find(item=>item.id==122).details" :title="banners.find(item=>item.id==122).title" :img="banners.find(item=>item.id==122).photo_file"/>
  <div class="w-60 mx-auto">
    <v-form v-model="valid"
            ref="form"
            class="pb-8"
            lazy-validation>
      <div class="mt-16 question-box white" v-for="(key,i) in Object.keys(form)">
        <h5 class="font-weight-bold tile-box">{{ key }}</h5>
        <!--      Input Form-->
        <v-row>
          <v-col class=" px-6 pb-1" v-for="(item,index) in form[key]" :key="index"
                 :cols="$vuetify.breakpoint.width<961?12:item.type===13||item.type===1?12:6">

            <p v-if="item.type!==13"
               :class="['font-weight-bold my-0 text-right mr-2']">
              {{ item.title_fa }}</p>
            <!--          Text Box-->
            <v-text-field
                style="min-width: 27vw!important;"
                :rules="emptyRulesItems(item.title_fa)?emptyRules:textRules"
                height="50"
                v-if="item.type===0"
                flat
                dense
                outlined
                v-model="item.model"
            ></v-text-field>
            <!--          TextArea-->

            <v-textarea
                no-resize
                rows="2"
                :rules="emptyRulesItems(item.title_fa)?emptyRules:textRules"
                height="100"
                v-if="item.type===1"
                flat
                dense
                outlined
                v-model="item.model"
            ></v-textarea>

            <!--          Number-->
            <v-text-field :rules="emptyRulesItems(item.title_fa)?emptyRules:textRules"
                          height="50"
                          v-if="item.type===2"
                          flat
                          dense
                          outlined
                          v-model="item.model"
            ></v-text-field>
            <!--          Email-->
            <v-text-field :rules="emptyRulesItems(item.title_fa)?emptyRules:textRules"
                          height="50"
                          v-if="item.type===3"
                          type="email"
                          flat
                          dense
                          outlined
                          v-model="item.model"
            ></v-text-field>
            <!--Date-->
            <div v-if="item.type===4||item.type===5" class="mb-6">
              <div>
                <date-picker
                    input-class="d-flex date-picker-style"
                    placeholder=""
                    v-model="item.model" type="year-month" color="#f3c303"/>

              </div>
            </div>
            <!-- Select-->
            <div v-if="item.type===6" :style="{'width':$vuetify.breakpoint.width<960?'': '27vw!important'}">
              <!--            <h1>{{ item.details_fa }}TYPE 6</h1>-->
              <v-select
                  height="50"
                  dense
                  :rules="emptyRulesItems(item.title_fa)?emptyRules:[v => !!v || 'لطفا یک آیتم انتخاب کنید']"
                  :items="item.details_fa.split('\n')"
                  v-model="item.model"
                  outlined
                  @change="getGender(item)"
              ></v-select>
            </div>
            <div v-if="item.type===9">
                <input type="file" @change=uploadFile($event,item.model)>
              </div>

          </v-col>
        </v-row>
        <!--      End Input Form-->
      </div>
      <div
          @click="sendForm"
          class="load-more mt-4"
      >
        <v-progress-circular
            size="30"
            width="4"
            color="white"
            indeterminate
            v-if="loading"
        >

        </v-progress-circular>
        <p class="load-more" v-else>{{ $t('send') }}</p>
      </div>
    </v-form>

    <v-snackbar
        :value="isError"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">مشکلی رخ داده است لطفا مجددا تلاش کنید.</p>
    </v-snackbar>
    <v-snackbar
        :value="isSuccess"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">درخواست شما با موفقیت ثبت شد.</p>
    </v-snackbar>
  </div>
</div>
</template>

<script>
import {mapState} from "vuex";
import AboutBanner from "../../About/Components/AboutBanner";
import {GET_FORM, SEND_FORM} from "../../../../../../store/formManagement/action_types";
export default {
  name: "AgenciesForm",
  components: {AboutBanner},
  data() {
    return {
      provinces: {
        Tehran:{
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `تهران`,
        },
        Alborz: {
          opacity: 1,
          bgColor: '#f00',
          tooltip : `البرز`,
        },
        Ardabil: { 
          opacity: 1,
          bgColor: '#e61175',
          tooltip : `اردبیل`,
        },
        AzerbaijanEast: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `آذربایجان شرقی`,
        },
        AzerbaijanWest: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `آذربایجان غربی`,
        },
        Bushehr: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `بوشهر`,
        },
        ChaharMahaalBakhtiari: { 
          opacity: 1,
          bgColor: '#f00',
          tooltip : `چهارمحال بختیاری`,
        },
        Fars: { 
          opacity: 1,
          bgColor: '#f00',
          tooltip : `فارس`,
        },
        Gilan: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `گیلان`,
        },
        Golestan: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `گلستان`,
        },
        Hamadan: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `همدان`,
        },
        Hormozgan: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `هرمزگان`,
        },
        Ilam: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `ایلام`,
        },
        Isfahan: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `اصفهان`,
        },
        Kerman: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `کرمان`,
        },
        Kermanshah: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `کرمانشاه`,
        },
        KhorasanNorth: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `خراسان شمالی`,
        },
        KhorasanRazavi: { 
          opacity: 1,
          bgColor: '#e61175',
          tooltip : `خراسان رضوی`,
        },
        KhorasanSouth: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `خراسان جنوبی`,
        },
        Khuzestan: { 
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `خوزستان`,
        },
        KohgiluyehBoyerAhmad: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `کهکیلویه بویراحمر`,
        },
        Kurdistan: { 
          opacity: 1,
          bgColor: '#e2041b',
          tooltip : `کردستان`,
        },
        Lorestan: { 
          opacity: 1,
          bgColor: '#e2041b',
          tooltip : `لرستان`,
        },
        Markazi: { 
          opacity: 1,
          bgColor: '#e61175',
          tooltip : `مرکزی`,
        },
        Mazandaran: { 
          opacity: 1,
          bgColor: '#e2041b',
          tooltip : `مازندران`,
        },
        Qazvin: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `قزوین`,
        },
        Qom: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `قم`,
        },
        Semnan: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `سمنان`,
        },
        SistanBaluchestan: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `سیستان و بلوچستان`,
        },
        Yazd: { 
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `یزد`,
        },
        Zanjan: { 
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `زنجان`,
        },
      },
      isError: false,
      isSuccess: false,
      loading: false,
      valid: false,
      textRules: [
        v => !!v || 'پر کردن فیلد الزامی است',
      ],
      emptyRules: [],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  methods: {
    checkMultiQuestionType(id) {
      return (id === 50 ||
          id === 53 ||
          id === 54 ||
          id === 57 ||
          id === 59
          || id === 51);
    },
    setMultiQuestionKeyValue(item, data) {
      switch (item.id) {
        case 51 :
          data.append(`customField_${item.id}`, JSON.stringify(this.jobExperiencesList));

          // data[`customField_${item.id}`] = this.jobExperiencesList;
          break;
        case 53:
          data.append(`customField_${item.id}`, JSON.stringify(this.languageList));

          // data[`customField_${item.id}`] = this.languageList;
          break;
        case 54:
          data.append(`customField_${item.id}`, JSON.stringify(this.computerSkillCount));

          // data[`customField_${item.id}`] = this.computerSkillCount;
          break;
        case 57:
          data.append(`customField_${item.id}`, JSON.stringify(this.introducedList));

          // data[`customField_${item.id}`] = this.introducedList;
          break;
        case 59:
          data.append(`customField_${item.id}`, JSON.stringify(this.dependantsList));

          // data[`customField_${item.id}`] = this.dependantsList;
          break;
        case 50:
          data.append(`customField_${item.id}`, JSON.stringify(this.educationList));

          // data[`customField_${item.id}`] = this.educationList;
          break;
      }
      console.log("multi",item,data)
  
    },
    uploadFile(e, model) {
      console.log(e);
      const image = e.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(image);
      this.resumeFile = e.target.files[0];
      console.log('file is :', this.resumeFile);
      reader.onload = e => {
        model = e.target.result;
      };
    },
    emptyRulesItems(title) {
      if (title == 'تعداد فرزند' || title == 'محل خدمت' || title == 'یگان خدمتی'
          || title == 'نوع معافیت' || title == 'نوع و علت معافیت'
          || title == 'تخصص ویژه' || title == 'توضیحات تخصص ویژه شما' || title == 'آیا تاکنون سابقه کیفری و سیاسی داشته اید؟' ||
          title == 'توضیح سوابق کیفری' || title == 'شماره عینک' || title == 'نوع کار فعلی' || title == 'خدمت نظام وظیفه') {
        return true;
      } else {
        return false
      }
    },
    getGender(item) {
      if (this.localizeTitle(item) === 'جنسیت') {
        console.log(item.model.toString());
        if (item.model.toString() == 'زن') {
          this.showMilitaryService = false;
        } else {
          this.showMilitaryService = true;
        }
      }
    },
    localizeTitle(item){
      if(this.lang == "en"){
        return item.title_en;
      }else if(this.lang == "ar"){
        return item.title_ar;
      }else{
        return item.title_fa;
      }
    },
    sendForm(){
      var catItems = Object.values(this.form);
      for (let i = 0; i < catItems.length; i++) {
        var currentKey = catItems[i];
        var item = Object.values(currentKey);
        for (let j = 0; j < item.length; j++) {
          var question = item[j];
          if (question.id === 19) {
            if (question.model == null) {
              if (this.showMilitaryService) {
                this.militaryEndTimeIsInvalid = true;
                Swal.fire(
                  'خطا',
                  'لطفا اطلاعات خدمت خود را وارد کنید',
                  'error'
                )
              }
            }
          }
          if (question.id === 7) {
            if (question.model == null) {
              this.birthdayIsInvalid = true;
              Swal.fire(
                  'خطا',
                  'لطفا تاریخ تولد خود را وارد کنید',
                  'error'
                )
            } else {
              this.birthdayIsInvalid = false;
            }
          }
        }
      }


      if(!this.loading){
               this.loading = true;
               var data = new FormData();
               var key;

               for (let i = 0; i < Object.keys(this.form).length; i++) {
                 let currentCategory = this.form[Object.keys(this.form)[i]];
                 for (let j = 0; j < currentCategory.length; j++) {
                   var item = currentCategory[j];
                   if (this.checkMultiQuestionType(item.id)) {
                     this.setMultiQuestionKeyValue(item, data);
                     console.log(this.setMultiQuestionKeyValue);
                   } else {
                     // data[`customField_${item.id}`] = item.model;
                     if (item.model != undefined) {
                       data.append(`customField_${item.id}`, item.model);
                     }

                   }
                 }

               }
               data.append(`api_key`, '402784613679330');
               data.append(`id`, '23');
               data.append(`customField_81`, this.resumeFile);
               data.id = 23;
               // data.api_key = '402784613679330';
               this.$store.dispatch(`formManagement/${SEND_FORM}`, data).then(
                   response => {
                     if (response) {
                       this.isSuccess = true;
                       setTimeout(() => {
                         this.$router.replace('/');
                       }, 3000)
                     } else {
                       this.isError = true;
                     }
                     this.loading = false;
                   }
               );
             }
    }
  },
  created() {
    if (this.banners==null){
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
    this.$store.dispatch('lightBlocksManagement/getAgenciesForm')
  },
  computed: {
    ...mapState({
      form: state => state.lightBlocksManagement.agenciesForm,
      banners: state => state.lightBlocksManagement.blockBanners,
    })
  }
}
</script>

<style scoped>
.tile-box {
  background: #c9c9c9;
  color: #7BAD32;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin-bottom: 16px;
}
.load-more {
  width: 200px;
  margin-bottom: 20px;
  padding: 0 22px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e8e8e8;
  font-weight: bold;
  cursor: pointer;
  background: #7BAD32;
}
.load-more:hover{
  background: #e8e8e8;
  color: #7BAD32;
  transition: all 0.5s;
}
</style>